import { tv } from '@heroui/react';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { IoWarningOutline } from 'react-icons/io5';
import { MdOutlineInfo } from 'react-icons/md';
import { VscError } from 'react-icons/vsc';
import { cn } from '../../cn';

const alert = tv({
  slots: {
    baseClass: 'flex items-start flex-col space-y-3 rounded w-full border border-l-8',
    textClass: 'text-sm',
    wrapperClass: 'flex flex-row items-center space-x-3',
    listClass: 'mt-2 ml-4 md:ml-10 list-inside list-disc',
  },
  variants: {
    type: {
      warn: { baseClass: 'border-warning-200 border-l-warning-500 bg-warning-50' },
      success: { baseClass: 'border-success-200 border-l-success-500 bg-success-50' },
      error: { baseClass: 'border-danger-200 border-l-danger-500 bg-danger-50' },
      info: { baseClass: 'border-sky-200 dark:border-sky-800 border-l-sky-500 bg-sky-50 dark:bg-sky-950' },
    },
    size: {
      sm: { textClass: 'text-xs md:text-sm', baseClass: 'px-4 py-3' },
      md: { textClass: 'text-sm md:text-md', baseClass: 'px-4 py-4' },
      lg: { textClass: 'text-lg', baseClass: 'px-4 py-5' },
    },
  },
});

// type AlertVariants = VariantProps<typeof alert>;
type AlertVariants = {
  type?: 'warn' | 'success' | 'error' | 'info';
  size?: 'sm' | 'md' | 'lg';
};

export interface IAlterProps extends React.ComponentProps<'div'>, AlertVariants {
  icon?: React.ReactNode;
  message: string;
  list?: string[];
}

export const Alert = ({
  type = 'warn',
  size = 'sm',
  icon,
  message,
  list,
  className,
  children,
}: IAlterProps) => {
  const { baseClass, textClass, wrapperClass, listClass } = alert();

  const mapping = {
    warn: <IoWarningOutline className='text-warning-700 w-7 h-7' />,
    success: <FaRegCircleCheck className='text-success-700 w-7 h-7' />,
    error: <VscError className='text-danger-700 w-7 h-7' />,
    info: <MdOutlineInfo className='text-sky-700 w-7 h-7' />,
  };

  return (
    <div className={cn(baseClass({ type, size }), className)}>
      {children || (
        <>
          <div className={wrapperClass()}>
            {icon || mapping[type]}
            <span className={textClass({ size })}>{message}</span>
          </div>
          {list && (
            <ul className={listClass()}>
              {list.map((i, idx) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: <disabled>
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <disabled>
                <li key={idx} className={textClass({ size })} dangerouslySetInnerHTML={{ __html: i }} />
                // <li className={textClass({ size })} key={idx}>
                //   {i}
                // </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};
